/* Sugestões no carrinho (snippets/fioh-cart-upsell.liquid).
   "Adicionar": põe o produto no carrinho. "Trocar pelo kit": adiciona o kit e só depois remove o
   item avulso (se a adição falhar, o carrinho fica como estava). A gaveta é redesenhada com a
   seção cart-drawer devolvida pela própria chamada. */
(function () {
  'use strict';
  if (window.__fiohCartUpsell) return;
  window.__fiohCartUpsell = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Erro ' + res.status);
        return data;
      });
    });
  }

  function render(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && state.sections) drawer.renderContents(state);
    if (typeof window.freeShippMsg === 'function') window.freeShippMsg();
  }

  /* Compre junto (página do produto): adiciona a seleção atual do formulário do tema (variante e
     quantidade, que o seletor de kits pode ter trocado) + o produto sugerido. Se a seleção já está
     no carrinho, adiciona só o sugerido, para não duplicar o pedido. */
  function together(btn, variant) {
    var formId = btn.getAttribute('data-form');
    var form = formId && document.getElementById(formId);
    var idInput = form && form.querySelector('[name="id"]');
    var qtyInput = form && (document.querySelector('input[name="quantity"][form="' + formId + '"]') || form.querySelector('[name="quantity"]'));
    var mainId = idInput ? Number(idInput.value) : 0;
    var mainQty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var inCart = cart.items.some(function (i) { return i.variant_id === mainId; });
        var items = [{ id: variant, quantity: 1 }];
        if (mainId && !inCart) items.unshift({ id: mainId, quantity: mainQty });
        return post('cart/add.js', { items: items, sections: 'cart-drawer' });
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cu-add], [data-cu-swap], [data-cu-together]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var box = btn.closest('[data-cu]');
    var err = box && box.querySelector('[data-cu-err]');
    if (err) err.hidden = true;
    btn.disabled = true;

    var variant = Number(btn.getAttribute('data-variant'));
    var job;
    if (btn.hasAttribute('data-cu-together')) {
      job = together(btn, variant);
    } else if (btn.hasAttribute('data-cu-swap')) {
      job = post('cart/add.js', { items: [{ id: variant, quantity: 1 }] }).then(function () {
        return post('cart/change.js', { id: btn.getAttribute('data-key'), quantity: 0, sections: 'cart-drawer' });
      });
    } else {
      job = post('cart/add.js', { items: [{ id: variant, quantity: 1 }], sections: 'cart-drawer' });
    }
    job = job.then(function (state) { btn.disabled = false; return state; });

    job.then(render).catch(function (error) {
      if (window.console) console.error('[Sugestões no carrinho]', error);
      if (err) err.hidden = false;
      btn.disabled = false;
    });
  });
})();
